import type { COLOR } from '@george-labs.com/design-system/types/utilsTS/color';
import { Avatar, getProductColorShade } from '@george-labs.com/design-system';
import type { AvatarProps } from '@george-labs.com/design-system/types/components/Image';

const DEFAULT_BACKGROUND_COLOR = Avatar.COLOR.BLUE_300;
const DEFAULT_COLOR = Avatar.COLOR.BLUE_100;

export const getAvatarProductColors = (
    productColor?: COLOR,
): Pick<AvatarProps, 'color' | 'backgroundColor'> => {
    if (productColor) {
        return {
            backgroundColor: getProductColorShade(productColor, 'weak'),
            color: getProductColorShade(productColor, 'strong'),
        };
    }

    return {
        backgroundColor: DEFAULT_BACKGROUND_COLOR,
        color: DEFAULT_COLOR,
    };
};
